export default __webpack_public_path__ + "static/media/seven.3df0ed4a.png";